import { useEffect, useState } from "react";

import { Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router";

import { DEFAULT_REQUEST } from "./constants";
import {
  getRequest,
  setEnrollmentInstitution,
} from "../../api/Request/RequestApi";
import { useAppDispatch } from "../../app/store";
import {
  ContentArea,
  ToolbarTop,
  ToolbarEdit,
  FormCard,
  RequestHeader,
  InstitutionSelect,
} from "../../components";
import { useAuth } from "../../hooks/auth/useAuth";
import { ValidationFailure, Role } from "../../models";
import { Request } from "../../models/Request";
import { requestAdminDetailsUrl } from "../../routes/routes";
import { setIsEdited } from "../../slices/applicationSlice";

export function EnrollmentInstitutionEdit() {
  const { id } = useParams<{ id: string }>();
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useAppDispatch();
  const auth = useAuth();

  const [item, setItem] = useState<Request>(DEFAULT_REQUEST);
  const [enrollmentInstitutionId, setEnrollmentInstitutionId] = useState(0);
  const [errors, setErrors] = useState<ValidationFailure[]>();

  useEffect(() => {
    (async () => {
      if (id && id !== "0") {
        var request = await getRequest(+id);
        if (request) {
          setItem(request);
          dispatch(setIsEdited());
        }
      }
    })();
  }, [id]);

  const handleEnrollmentInstitutionIdChange = (e: any) => {
    const val = Number.parseInt(e.target.value);
    setEnrollmentInstitutionId(val && !isNaN(val) ? val : 0);
  };
  return (
    <ContentArea>
      <ToolbarTop
        showAdd={"hide"}
        showBack={"show"}
        showEdit={"hide"}
        pageTitle={t("request.changeEnrollmentInstitution")}
        errors={errors}
      />
      <RequestHeader request={item} />
      <FormCard cardTitle={t("common.schoolCandidateModel.institutionList")}>
        <Row>
          <Col md={3}>{t("common.schoolCandidateModel.institutionList")}</Col>
          <Col md={9}>
            <InstitutionSelect
              label={t("common.schoolCandidateModel.institutionList")}
              name={"enrollmentInstitutionId"}
              //countyIds={auth.currentRole?.claimType === ClaimType.County ? auth.currentRole.locations : undefined}
              countyId={
                auth.currentRole?.role === Role.CAS ||
                auth.currentRole?.role === Role.Helpdesk
                  ? undefined
                  : item.countyId
              }
              showUser={true}
              //excludeIds={[item.e]} // We should exclude the existing but it is not a property on the Request :(
              onChange={handleEnrollmentInstitutionIdChange}
              shouldCheckParentCounty
              value={
                enrollmentInstitutionId !== 0
                  ? enrollmentInstitutionId
                  : undefined
              }
            />
          </Col>
        </Row>
      </FormCard>
      <ToolbarEdit
        showCancel={"show"}
        showSave={enrollmentInstitutionId !== 0 ? "show" : "disable"}
        isEdited={true}
        onClickCancel={history.goBack}
        handleSave={async () =>
          await setEnrollmentInstitution(item.id, enrollmentInstitutionId)
        }
        setSaveErrors={setErrors}
        redirectUrlSaveOK={() => requestAdminDetailsUrl(+id)}
        showCustom={false}
      />
    </ContentArea>
  );
}
